module.exports = __webpack_public_path__ + "static/media/grayCoppy.svg";